import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminUsersApi } from '../api/admin-users.api';
import { adminUserKeys } from './queryKeys';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';

interface ChangeRoleParams {
  adminUserId: string;
  roleId: string;
}

export const useChangeAdminUserRole = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ adminUserId, roleId }: ChangeRoleParams) =>
      adminUsersApi.changeUserRole(adminUserId, { roleId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminUserKeys.all });
      Notification.success({
        title: 'Rol actualizado',
        description: 'El rol del administrador ha sido actualizado exitosamente.',
      });
    },
  });
};
